'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$Segment(key, heroSolo, primaryCta, secondaryCta, hero, problem, solution, how, value, stats, useCases, impl, trust, cta) {
  this.dn = null;
  this.gC = false;
  this.dN = null;
  this.fD = null;
  this.gB = null;
  this.gD = null;
  this.d4 = null;
  this.el = null;
  this.ep = null;
  this.em = null;
  this.eo = null;
  this.dM = null;
  this.en = null;
  this.d3 = null;
  this.dn = key;
  this.gC = heroSolo;
  this.dN = primaryCta;
  this.fD = secondaryCta;
  this.gB = hero;
  this.gD = problem;
  this.d4 = solution;
  this.el = how;
  this.ep = value;
  this.em = stats;
  this.eo = useCases;
  this.dM = impl;
  this.en = trust;
  this.d3 = cta;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$Segment as $c_Lio_intela_sites_digitalinternship_data_Segments$Segment };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$Segment.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$Segment;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$Segment() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$Segment as $h_Lio_intela_sites_digitalinternship_data_Segments$Segment };
$h_Lio_intela_sites_digitalinternship_data_Segments$Segment.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (-656591085));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.dn));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.gC ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.dN));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.fD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gB));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.d4));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.el));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.ep));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.em));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.eo));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.dM));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.en));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.d3));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().Q(acc, 14);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$Segment)) {
    if ((this.gC === x$0.gC)) {
      var x = this.dn;
      var x$2 = x$0.dn;
      var $x_12 = (x === x$2);
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$3 = this.dN;
      var x$4 = x$0.dN;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.fD;
      var x$6 = x$0.fD;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.gB;
      var x$8 = x$0.gB;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.gD;
      var x$10 = x$0.gD;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.d4;
      var x$12 = x$0.d4;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.el;
      var x$14 = x$0.el;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : x$13.i(x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.ep;
      var x$16 = x$0.ep;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : x$15.i(x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.em;
      var x$18 = x$0.em;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : x$17.i(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.eo;
      var x$20 = x$0.eo;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : x$19.i(x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.dM;
      var x$22 = x$0.dM;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : x$21.i(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.en;
      var x$24 = x$0.en;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : x$23.i(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$25 = this.d3;
      var x$26 = x$0.d3;
      return ((x$25 === null) ? (x$26 === null) : x$25.i(x$26));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 14;
});
$p.I = (function() {
  return "Segment";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.dn;
      break;
    }
    case 1: {
      return this.gC;
      break;
    }
    case 2: {
      return this.dN;
      break;
    }
    case 3: {
      return this.fD;
      break;
    }
    case 4: {
      return this.gB;
      break;
    }
    case 5: {
      return this.gD;
      break;
    }
    case 6: {
      return this.d4;
      break;
    }
    case 7: {
      return this.el;
      break;
    }
    case 8: {
      return this.ep;
      break;
    }
    case 9: {
      return this.em;
      break;
    }
    case 10: {
      return this.eo;
      break;
    }
    case 11: {
      return this.dM;
      break;
    }
    case 12: {
      return this.en;
      break;
    }
    case 13: {
      return this.d3;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Segment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bH)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Segment as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Segment };
var $d_Lio_intela_sites_digitalinternship_data_Segments$Segment = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$Segment, "io.intela.sites.digitalinternship.data.Segments$Segment", ({
  bH: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$Segment as $d_Lio_intela_sites_digitalinternship_data_Segments$Segment };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Segment.js.map
